module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1yRps"))).then(() => module.bundle.root('d0iPb'));